export const RootUri = '/home';

export const createDetailUri =
  (root: string) => (id: string | number | undefined) =>
    `${root}/${id}`;

export const ProjectUri = '/projects';
export const BuildUri = '/builds';
export const BuildFileUri = '/buildFile';

export const ProjectDetailUri = createDetailUri(ProjectUri);
export const BuildFilesUri = (version: string | number, name: string) =>
  `/buildFile/${name}/${version}`;
